'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILink from 'UIComponents/link/UILink';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { isHSFXEligibleSelector } from '../../selectors/PromotionSelectors';
import { getSuiteLegalDisclaimerUrl } from 'pricing-pages-lib/utils/urls';
const Bold = styled.b.withConfig({
  displayName: "CRMSuiteAlert__Bold",
  componentId: "sc-1pnr2sf-0"
})(["font-size:16px;"]);

const CRMSuiteAlert = ({
  suiteProductLevel
}) => {
  const isHSFXEligible = useSelector(isHSFXEligibleSelector);

  if (isHSFXEligible || !suiteProductLevel) {
    return null;
  }

  return /*#__PURE__*/_jsx(UIAlert, {
    type: "info",
    className: "m-bottom-8",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: `pricingPage.planBuilder.crmSuiteAlert.${suiteProductLevel}_jsx`,
      elements: {
        UILink,
        Bold
      },
      options: {
        link: getSuiteLegalDisclaimerUrl(),
        onClick: () => {
          getUsageTracker().track('externalLinkClick', {
            name: 'crm-suite-terms',
            url: getSuiteLegalDisclaimerUrl()
          });
        }
      }
    })
  });
};

export default CRMSuiteAlert;